import * as React from "react"
import { SVGProps } from "react"
const NoData = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlSpace="preserve" width={props?.width || "50%"} height={props?.height || "50%"} {...props} viewBox="350 350 350 350">
    <path
      d="M338.53 315.16H124.37a9.65 9.65 0 0 1-9.44-8.81l-10.52-146.13a8.1 8.1 0 0 1 8.17-8.8h214.16a9.65 9.65 0 0 1 9.44 8.8l10.52 146.13a8.1 8.1 0 0 1-8.17 8.81Z"
      style={{
        stroke: "none",
        strokeWidth: 2,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#fff",
        fillRule: "nonzero",
        opacity: 0.5,
      }}
      transform="matrix(.9 0 0 .8 339.306 349.898)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M332.85 300.58H128a3.49 3.49 0 0 1-3.42-3.2l-8.65-120.17a2.92 2.92 0 0 1 3-3.19h204.9a3.48 3.48 0 0 1 3.42 3.19l8.66 120.17a2.94 2.94 0 0 1-3.06 3.2Z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#fff",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="matrix(.93 0 0 .93 332.194 314.881)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m20.63 26.2-3.35-46.32L7.19-26.2h-27.82l3.79 52.4h37.47z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#fff",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(541.08 535.31)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M246.53 255.28h-37.47a.48.48 0 0 1-.49-.45l-3.77-52.4a.47.47 0 0 1 .13-.36.48.48 0 0 1 .35-.16h27.81a.55.55 0 0 1 .25.07l10.1 6.08a.48.48 0 0 1 .24.38l3.32 46.32a.46.46 0 0 1-.13.37.47.47 0 0 1-.34.15Zm-37-1H246l-3.28-45.55-9.72-5.85h-27.2Z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#a29e9e",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(314.1 288.47)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m5.05 2.05-10.1-6.08 3.71 8.06 6.39-1.98z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#ebebeb",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(552.31 495.14)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M236.8 210.94a.49.49 0 0 1-.44-.28l-3.71-8.06a.5.5 0 0 1 .11-.57.5.5 0 0 1 .58-.05l10.1 6.08a.5.5 0 0 1 .24.48.49.49 0 0 1-.34.4l-6.4 2Zm-2.61-7.32 2.87 6.25 5-1.53Z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#a29e9e",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(314.18 288.7)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M202.26 265.15h2.26l3.26 4.34-.31-4.34h2.28l.56 7.84H208l-3.24-4.31.31 4.31h-2.28Z"
      style={{
        stroke: "none",
        strokeWidth: 2,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#a29e9e",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="matrix(2.96 0 0 3.01 -142.019 -243.75)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M211.33 269.07a3.8 3.8 0 0 1 .86-3 3.76 3.76 0 0 1 2.9-1.07 4.38 4.38 0 0 1 3.09 1.05 4.32 4.32 0 0 1 1.27 2.94 4.77 4.77 0 0 1-.3 2.25 3 3 0 0 1-1.24 1.37 4.16 4.16 0 0 1-2.14.49 5.25 5.25 0 0 1-2.23-.42 3.62 3.62 0 0 1-1.5-1.34 4.66 4.66 0 0 1-.71-2.27Zm2.43 0a2.73 2.73 0 0 0 .56 1.7c.316.348.77.539 1.24.52a1.38 1.38 0 0 0 1.17-.51A2.75 2.75 0 0 0 217 269a2.57 2.57 0 0 0-.56-1.62 1.64 1.64 0 0 0-1.25-.51 1.38 1.38 0 0 0-1.14.52 2.53 2.53 0 0 0-.29 1.7Z"
      style={{
        stroke: "none",
        strokeWidth: 2,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#a29e9e",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="matrix(3 0 0 3.05 -147.89 -254.232)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M224.15 265.15h3.6a4.51 4.51 0 0 1 1.74.29c.44.184.83.468 1.14.83.315.367.556.792.71 1.25a6.3 6.3 0 0 1 .3 1.52 5.08 5.08 0 0 1-.15 1.95 2.8 2.8 0 0 1-.71 1.16 2.3 2.3 0 0 1-1 .62 5.6 5.6 0 0 1-1.43.22h-3.59Zm2.55 1.78.31 4.28h.59a2.45 2.45 0 0 0 1.07-.17 1 1 0 0 0 .46-.59 3.54 3.54 0 0 0 .08-1.36 2.72 2.72 0 0 0-.53-1.7 1.81 1.81 0 0 0-1.38-.46Z"
      style={{
        stroke: "none",
        strokeWidth: 2,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#a29e9e",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="matrix(3 0 0 3.05 -142.92 -254.793)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M237.45 271.69h-2.75l-.29 1.3h-2.47l2.38-7.84H237l3.51 7.84h-2.54Zm-.63-1.69-1.06-2.82-.66 2.82Z"
      style={{
        stroke: "none",
        strokeWidth: 2,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#a29e9e",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="matrix(2.91 0 0 2.96 -116.73 -230.167)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.37 265.15h7.36l.14 1.94h-2.47l.42 5.9h-2.42l-.42-5.9h-2.47Z"
      style={{
        stroke: "none",
        strokeWidth: 2,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#a29e9e",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="matrix(2.93 0 0 2.98 -119.072 -235.249)"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252.37 271.69h-2.75l-.29 1.3h-2.47l2.38-7.84h2.64l3.5 7.84h-2.53Zm-.63-1.69-1.07-2.82L250 270Z"
      style={{
        stroke: "none",
        strokeWidth: 2,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeDashoffset: 0,
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        fill: "#a29e9e",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="matrix(3.08 0 0 3.03 -155.92 -248.812)"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
)
export default NoData;
